import { createContext, useContext } from "react";
import type { useNotificationSnapshot } from "../hooks/useNotificationSnapshot";

type NotificationContextValue = {
  query: ReturnType<typeof useNotificationSnapshot>;
  open: boolean;
  setOpen: (open: boolean) => void;
};
export const NotificationContext = createContext<NotificationContextValue | null>(null);
export const useNotifications = () => useContext(NotificationContext);
